import React from 'react'
import logo from '../../images/logow.svg'
import styles from './logo.module.css'

const Logo = () => (
  <img src={logo} className={styles.logo} alt='Stockholm Kartell' />
)
export default Logo